export default __webpack_public_path__ + "static/media/Logo.59030f8c.png";